import { render } from "./LatePermissionApply.vue?vue&type=template&id=64017704"
import script from "./LatePermissionApply.vue?vue&type=script&lang=js"
export * from "./LatePermissionApply.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__